import SavingsBanner from './SavingsBanner';

export default {
  SavingsBanner,
};
